import { render, staticRenderFns } from "./HedgingPositions.vue?vue&type=template&id=56566b8c&scoped=true"
import script from "./HedgingPositions.vue?vue&type=script&lang=js"
export * from "./HedgingPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56566b8c",
  null
  
)

export default component.exports